import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import React from "react";
import { dressPage1 } from "../../../Data/dress/page1";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  findProducts,
  toggleProductActive,
} from "../../../Redux/Customers/Product/Action";

const ProductsTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customersProduct } = useSelector((store) => store);
  const [filterValue, setFilterValue] = useState({
    availability: "",
    category: "",
    sort: "",
  });

  // Toggle active confirmation modal state
  const [toggleDialogOpen, setToggleDialogOpen] = useState(false);
  const [productToToggle, setProductToToggle] = useState(null);

  // query
  const searchParams = new URLSearchParams(location.search);
  const availability = searchParams.get("availability");
  const category = searchParams.get("category");
  const sort = searchParams.get("sort");
  const page = searchParams.get("page");

  const handlePaginationChange = (event, value) => {
    searchParams.set("page", value - 1);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  useEffect(() => {
    // Akhil comments - setFilterValue commented out
    // setFilterValue({ availability, category, sort });
    const data = {
      category: category || "",
      colors: [],
      sizes: [],
      minPrice: 0,
      maxPrice: 100000,
      minDiscount: 0,
      sort: sort || "price_low",
      pageNumber: page || 0,

      pageSize: 10,
      stock: availability,
    };
    console.log("Admin ProductsTable - Fetching products with data:", data);
    dispatch(findProducts(data));
  }, [availability, category, sort, page, customersProduct.deleteProduct, customersProduct.toggleProduct]);

  const handleFilterChange = (e, sectionId) => {
    console.log(e.target.value, sectionId);
    setFilterValue((values) => ({ ...values, [sectionId]: e.target.value }));
    searchParams.set(sectionId, e.target.value);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  // Toggle active confirmation handlers
  const handleOpenToggleDialog = (product) => {
    setProductToToggle(product);
    setToggleDialogOpen(true);
  };

  const handleCloseToggleDialog = () => {
    setToggleDialogOpen(false);
    setProductToToggle(null);
  };

  const handleConfirmToggle = () => {
    if (productToToggle) {
      dispatch(toggleProductActive(productToToggle.id));
    }
    handleCloseToggleDialog();
  };

  // Edit product handler
  const handleEditProduct = (productId) => {
    navigate(`/admin/product/update/${productId}`);
  };

  return (
    <Box width={"100%"}>
      <Card className="mt-2">
        <CardHeader
          title="All Products"
          sx={{
            pt: 2,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        <TableContainer>
          <Table sx={{ minWidth: 800 }} aria-label="table in dashboard">
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Image</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Title</TableCell>
                <TableCell sx={{ textAlign: "center", fontWeight: 'bold' }}>Category</TableCell>
                <TableCell sx={{ textAlign: "center", fontWeight: 'bold' }}>Price</TableCell>
                <TableCell sx={{ textAlign: "center", fontWeight: 'bold' }}>Quantity</TableCell>
                <TableCell sx={{ textAlign: "center", fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ textAlign: "center", fontWeight: 'bold' }}>Edit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customersProduct?.products?.content?.map((item) => (
                <TableRow
                  hover
                  key={item.id}
                  sx={{ "&:last-of-type td, &:last-of-type th": { border: 0 }, opacity: item.active === false ? 0.5 : 1 }}
                >
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    {" "}
                    <Avatar alt={item.title} src={item.imageUrl} />{" "}
                  </TableCell>


                  <TableCell
                    sx={{ py: (theme) => `${theme.spacing(0.5)} !important` }}
                  >
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "0.875rem !important",
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography variant="caption">{item.brand}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {item.category?.name || "No Category"}
                  </TableCell>

                  <TableCell sx={{ textAlign: "center" }}>
                    ${(parseFloat(item.discountedPrice) || 0).toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {item.quantity}
                  </TableCell>

                  <TableCell sx={{ textAlign: "center" }}>
                    <Chip
                      label={item.active !== false ? "Active" : "Inactive"}
                      color={item.active !== false ? "success" : "default"}
                      size="small"
                      onClick={() => handleOpenToggleDialog(item)}
                      sx={{ cursor: "pointer" }}
                    />
                  </TableCell>

                  <TableCell sx={{ textAlign: "center" }}>
                    <IconButton
                      color="primary"
                      onClick={() => handleEditProduct(item.id)}
                      title="Edit Product"
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
      <Card className="mt-2 border">
        <div className="mx-auto px-4 py-5 flex justify-center shadow-lg rounded-md">
          <Pagination
            count={customersProduct.products?.totalPages}
            color="primary"
            className=""
            onChange={handlePaginationChange}
          // value={page}
          />
        </div>
      </Card>

      {/* Toggle Active Confirmation Dialog */}
      <Dialog
        open={toggleDialogOpen}
        onClose={handleCloseToggleDialog}
        aria-labelledby="toggle-dialog-title"
        aria-describedby="toggle-dialog-description"
      >
        <DialogTitle id="toggle-dialog-title">
          {productToToggle?.active !== false ? "Deactivate Product" : "Reactivate Product"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="toggle-dialog-description">
            {productToToggle?.active !== false
              ? "Are you sure you want to deactivate this product? It will be hidden from customers but can be reactivated later."
              : "Are you sure you want to reactivate this product? It will become visible to customers again."}
          </DialogContentText>
          {productToToggle && (
            <Box sx={{ mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Avatar
                  src={productToToggle.imageUrl}
                  alt={productToToggle.title}
                  sx={{ width: 50, height: 50, mr: 2 }}
                />
                <Box>
                  <Typography variant="body1" fontWeight="500">
                    {productToToggle.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {productToToggle.brand}
                  </Typography>
                </Box>
              </Box>
              <Typography variant="body2">
                <strong>ID:</strong> {productToToggle.id}
              </Typography>
              <Typography variant="body2">
                <strong>Category:</strong> {productToToggle.category?.name || "No Category"}
              </Typography>
              <Typography variant="body2">
                <strong>Price:</strong> ${productToToggle.discountedPrice?.toFixed(2) || "0.00"}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseToggleDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmToggle}
            color={productToToggle?.active !== false ? "warning" : "success"}
            variant="contained"
          >
            {productToToggle?.active !== false ? "Deactivate" : "Reactivate"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProductsTable;
